export default __webpack_public_path__ + "static/media/srisailamHistoryTwo.a0406b88.jpg";